/* unplugin-vue-components disabled */import script from "./manual-test-status-icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./manual-test-status-icon.vue?vue&type=script&lang=ts&setup=true"

import "./manual-test-status-icon.vue?vue&type=style&index=0&id=592ca4f0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-592ca4f0"]])

export default __exports__